import {HttpClient, HttpParams} from '@angular/common/http';
import { Injectable } from "@angular/core";
import { ConfigService } from "@docma-mm-core/config/config.service";
import { BasedataService } from "@docma-mm-core/shared/basedata.service";
import {catchError, Observable} from 'rxjs';
import {AttributeGroupData} from '@docma-mm-core/attribute-group/attribute-group';
import {DefaultFlexAlignDirective} from '@angular/flex-layout';
import {DelayData} from '@docma-mm-core/delay/delay';

@Injectable()
export class DelayApiService extends BasedataService {

  private delayUrl: string = '/delays';

  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }

  private getDelayUrl() {
    return super.getFullUrl(this.delayUrl);
  }

  getDelayImage(delayId: number): Observable<Blob> {
    const endpoint = this.getDelayUrl() + '/' + delayId + '/image';

    return this.http
      .get(endpoint, {headers: this.getHeaders(), responseType: 'blob'});
  }

  getDelays(top: number = 1000, skip: number = 0): Observable<DelayData> {
    const endpoint = this.getDelayUrl();
    let httpParams = new HttpParams();
    if (top) {
      httpParams = httpParams.set('$top', top.toString());
    }
    if (skip) {
      httpParams = httpParams.set('$skip', skip.toString());
    }
    return this.http
      .get<DelayData>(endpoint, { headers: this.getHeaders(), params: httpParams })
      .pipe(catchError(e  => this.handleError(e)));
  }

}
